import CustomerList from "../components/Customers/CustomerList";

/**
 * Customers page component
 */
const Customers = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">Customers</h1>
      <div className="card">
        <CustomerList />
      </div>
    </div>
  );
};

export default Customers;
